import { render, staticRenderFns } from "./PressaBanner.vue?vue&type=template&id=ade5abf0&scoped=true&"
import script from "./PressaBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PressaBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PressaBanner.vue?vue&type=style&index=0&id=ade5abf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade5abf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade5abf0')) {
      api.createRecord('ade5abf0', component.options)
    } else {
      api.reload('ade5abf0', component.options)
    }
    module.hot.accept("./PressaBanner.vue?vue&type=template&id=ade5abf0&scoped=true&", function () {
      api.rerender('ade5abf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/PressaBanner.vue"
export default component.exports